import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import * as React from 'react';

export type TypographyProps = MuiTypographyProps & {
  text?: string;
  /* Used to further customize what the typography is rendered as */
  component?: React.ElementType;
};

export const Typography = (props: TypographyProps) => {
  const { text, ...restOfProps } = props || {};
  if (text) {
    return <MuiTypography {...restOfProps}>{text}</MuiTypography>;
  }
  return <MuiTypography {...restOfProps} />;
};
